import type { FC } from 'react'

export const HealthDeclarationPage: FC = () => {
  return (
    <div>
      <iframe
        id="patient-onboarding"
        title="patient-onboarding"
        width="100%"
        className="h-dvh"
        src="https://patient-onboarding-frontend-s6ijeu3yuq-lz.a.run.app/"
      />
    </div>
  )
}
